import React, { useState, useEffect } from "react";
import DesktopSubNavigation from './DesktopSubNavigation'
import TabletMobileSubNavigation from './TabletMobileSubNavigation'
require("../Navigation/Navigation.scss");


const SubNavigation = ({
  subnavdata,
  calloutdata,
  heading,
  subheading,
  designcheckbox,
  displaylink,
  displaytext,
  displaytitle,
}) => {
  const [device, setDevice] = useState("")

  useEffect(() => {
    const deviceSetup = () => {
      const width = window.innerWidth;
      if(width < 768) {
        setDevice('mobile');
      } else if(width <= 1024) {
        setDevice('tablet');
      } else {
        setDevice('desktop');
      }
    }
    deviceSetup();
    window.addEventListener('resize', deviceSetup);
    return () => {
      window.removeEventListener('resize', deviceSetup);
    }
  }, [])
  
  return (
    <>
     {device === 'desktop' ? 
     <DesktopSubNavigation
      subnavdata={subnavdata}
      calloutdata={calloutdata}
      heading={heading}
      subheading={subheading}
      designcheckbox={designcheckbox}
      displaylink={displaylink}
      displaytext={displaytext}
      displaytitle={displaytitle} /> 
      :
     <TabletMobileSubNavigation
      subnavdata={subnavdata}
      calloutdata={calloutdata}
      heading={heading}
      subheading={subheading}
      designcheckbox={designcheckbox}
      displaylink={displaylink}
      displaytext={displaytext}
      displaytitle={displaytitle}  />}
    </>
  );
};

export default SubNavigation;
